import React, {useCallback, useEffect, useState} from 'react';
import axios from 'axios';
import {useNavigate} from 'react-router-dom';
import {ArrowLeft, Database, Warning} from '@phosphor-icons/react';
import {SigninForm} from '../molecules/SigninForm';
import {NEUGENCE_API_BASE, bearerHeaders, fmtNumber, fmtTimestamp} from './_lib';

export default function ProspectPool() {
	const navigate = useNavigate();
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const signedIn = typeof window !== 'undefined' && !!sessionStorage.getItem('signedin');

	const load = useCallback(async () => {
		setLoading(true); setError(null);
		try {
			const headers = await bearerHeaders();
			const res = await axios.get(`${NEUGENCE_API_BASE}/api/v1/prospects/pool`, {headers});
			setData(res.data || {});
		} catch (e) { setError(e.message); }
		finally { setLoading(false); }
	}, []);

	useEffect(() => { if (signedIn) load(); }, [load, signedIn]);
	if (!signedIn) return <div style={{marginTop: 300}}><SigninForm/></div>;

	const files = (data && data.files) || [];

	return (
		<div className="min-h-screen bg-white text-left">
			<div className="max-w-5xl mx-auto px-6 py-10">
				<button onClick={() => navigate('/dashboard')} className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mb-6">
					<ArrowLeft size={14}/> Dashboard
				</button>
				<div className="mb-8">
					<h1 className="text-3xl font-semibold tracking-tight text-slate-900 flex items-center gap-3">
						<Database size={28} weight="duotone" color="#0ea5e9"/> Prospect pool
					</h1>
					<p className="text-sm text-slate-500 mt-1">Discovery output ready for outbound. Counts per source-method file.</p>
				</div>

				{error && <div className="rounded-xl border border-amber-200 bg-amber-50 p-5 mb-6"><Warning size={18} className="text-amber-600 inline mr-2"/>{String(error)}</div>}
				{loading && <div className="text-center text-sm text-slate-500 py-20">Loading…</div>}

				{!loading && data && data.available === false && (
					<div className="rounded-2xl border border-slate-200 bg-white p-10 text-center text-sm text-slate-500">
						Prospect-pool directory not visible to this server. Run the lookalike_prospector locally to view.
					</div>
				)}

				{!loading && data && data.available && (
					<>
						<div className="rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 mb-4 text-sm text-emerald-900">
							Total available: <strong>{fmtNumber(data.total_lines || 0)}</strong> prospects across <strong>{files.length}</strong> source-method files.
						</div>
						<div className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
							<table className="w-full text-sm">
								<thead className="bg-slate-50 text-slate-600 text-xs uppercase tracking-wide">
									<tr>
										<th className="text-left px-5 py-3">Source file</th>
										<th className="text-right px-3 py-3">Prospects</th>
										<th className="text-right px-3 py-3">Size</th>
										<th className="text-left px-3 py-3">Last modified</th>
									</tr>
								</thead>
								<tbody>
									{files.map(f => (
										<tr key={f.name} className="border-t border-slate-100">
											<td className="px-5 py-2 text-slate-900 text-xs">{f.name}</td>
											<td className="px-3 py-2 text-right text-slate-700">{fmtNumber(f.lines)}</td>
											<td className="px-3 py-2 text-right text-slate-500 text-xs">{(f.size_bytes/1024).toFixed(1)} KB</td>
											<td className="px-3 py-2 text-slate-500 text-xs">{f.modified_iso}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</>
				)}
			</div>
		</div>
	);
}
